import axios from './axios';
import utils from '../libs/utils';

const baseUrl = 'v1/erp-business-web/';
export default {
  axios,
  getPromoteList(params) { // 获取活动列表
    return axios.post(`${baseUrl}promote/sale/list`, params);
  },
  getPromoteInfo(params) { // 获取活动详情
    return axios.post(`${baseUrl}promote/sale/info`, utils.exchangeParams(params));
  },
  promoteSave(params) { // 保存促销活动
    return axios.post(`${baseUrl}promote/sale/save`, params);
  },
  promoteSubmit(params) { // 提交促销活动
    return axios.post(`${baseUrl}promote/sale/save/submit`, params);
  },
  promoteStop(params) { // 停止促销活动
    return axios.post(`${baseUrl}promote/sale/stop`, utils.exchangeParams(params));
  },
  promoteCallback(params) { // 撤回促销活动
    return axios.post(`${baseUrl}promote/sale/callback`, utils.exchangeParams(params));
  },
  promoteDelete(params) { // 删除促销活动
    return axios.post(`${baseUrl}promote/sale/delete`, utils.exchangeParams(params));
  },
  importActivity(params) { // 导入
    return axios.post(`${baseUrl}promote/sale/import`, params,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  },
  getActivityList(params) { // 批量创建时 获取数据
    return axios.get(`${baseUrl}promote/sale/import/list?${utils.exchangeParams(params)}`);
  },
  submitActivityList(params) { // 提交 批量活动
    return axios.post(`${baseUrl}promote/sale/import/submit`, utils.exchangeParams(params));
  },
};
